module.exports = __webpack_public_path__ + "static/media/prawy-dol-atmo.2ef2b6bb.svg";